import React from 'react';
import Analyzes from './Tabs';
import ContentLayout from '../layout/ContentLayout';
import { useTranslation } from 'react-i18next';

function Statistic() {
    const { t } = useTranslation();

    return (
        <ContentLayout title={`${t('nav_analytics')}`} isHideTitleMobile={true}>
            <Analyzes />
        </ContentLayout>
    );
}

export default React.memo(Statistic);
